// src/common/components/ItemCardHeader/ItemCardHeader.tsx
import React from "react";
import { useTheme } from "../../hooks/useTheme";
import styles from "./ItemCardHeader.module.scss";
import { formatPriceToLocale } from "../../utils/functions/formatPriceToLocale";

interface ItemCardHeaderProps {
  name: string;
  price: string | number;
  pricePrefix?: string;
  textColor?: string;
  small?: boolean;
}

export const ItemCardHeader: React.FC<ItemCardHeaderProps> = ({
  name,
  price,
  pricePrefix = "",
  textColor,
  small = false,
}) => {
  const { theme } = useTheme();

  const formatPrice = () => {
    if (price === "Нет цены" || price === 0 || typeof price === "string") {
      return "Нет цены";
    }
    return `${pricePrefix}${formatPriceToLocale(price)} ₽`;
  };

  return (
    <div className={`${styles.header} ${small ? styles.small : ""}`}>
      <span className={styles.name} style={{ color: textColor ?? theme.text }}>
        {name}
      </span>
      <span className={styles.price} style={{ color: theme.primary }}>
        {formatPrice()}
      </span>
    </div>
  );
};
